import Aos from 'aos';
import React, { useEffect } from 'react'

function WhyWeExist() {
    useEffect(() => {
        Aos.init({
            duration: 1000, // animation speed
            once: true,     // run only once
            easing: "ease-out",
        });
    }, []);
    return (
        <>
            <section
                className="relative overflow-hidden mt-[50px] lg:mt-[72px]"
            >
                <img
                    src="/assets/home/udbanner.jpg"
                    alt="Why We Exist Background"
                    className="h-[250px] lg:h-[363px] w-full object-cover"
                />
                <div className="absolute inset-0 bg-black/45 lg:bg-black/50"></div>
                <div className="absolute inset-0 flex items-center">
                    <div className="max-w-[1440px] mx-auto w-full px-[20px] lg:px-[70px]">
                        <div className="max-w-[700px]">
                            <h6
                                data-aos="fade-up"
                                data-aos-delay="150"
                                className=" pb-[0px] font-neue font-[400] text-[28px] md:text-[36px] leading-[40px] md:leading-[52px] text-[#ffff] text-left mt-[10px]"
                            >About
                            </h6>

                            <h6
                                data-aos="fade-up"
                                data-aos-delay="400"
                                className="pt-[2px] pb-[8px] font-neue font-[400] text-white text-[18px] sm:text-[20px] md:text-[22px] lg:text-[24px] leading-[30px] sm:leading-[38px] md:leading-[46px] lg:leading-[52px]"
                            >
                                A decade in the U.S.-India corridor.
                            </h6>
                        </div>
                    </div>
                </div>
            </section>
            <div className='part-2 lg:px-[70px] overflow-hidden px-[20px] max-w-[1440px] mx-auto pt-[60px] sm:pt-[80px] lg:pt-[100px] pb-[60px] sm:pb-[80px] lg:pb-[100px]'>
                <div className='part-2-div part-2-div2' data-aos="fade-up" data-aos-duration="1000">
                    <div
                        className='part-2-div-right'
                        data-aos="fade-right"
                        data-aos-delay="200"
                    >
                        <p>
                            IndUS Tech JGJ Ventures LLC ("IndUS Tech") is a commercial strategy firm advising companies and investors in U.S.-India defense, technology, and industry. It is built on the conviction that, in this market, policy creates opportunities and sets constraints, but does not build the business. Building a business takes buyers, partners, and capital, with each reinforcing and unlocking the others. Lobbyists, bankers, and consultants each handle one piece. We design the strategy that connects the forces shaping a business's growth and stay with our clients for the long term.
                        </p>
                        <p className='mt-2'>
                            IndUS Tech was founded by Kriti Upadhyaya, who brings a decade of work on U.S.-India defense and industrial strategy. Her experience spans think tanks, startups, listed companies, and promoter-led conglomerates in both countries. She holds an M.A. in International Affairs from American University and an M.S. in Finance from Johns Hopkins Carey Business School. Kriti writes and comments regularly on the U.S.-India relationship in leading publications and media.
                        </p>
                    </div>
                    <div
                        className='part-2-div-left part-2-div-left2'
                        data-aos="fade-left"
                        data-aos-delay="350"
                    >
                        <img src="/assets/our/indus3.jpeg" className='' alt="" />
                    </div>

                </div>
            </div>


            {/* <section
                className="pt-[60px] pb-[80px] sm:pt-[80px] sm:pb-[102px] lg:px-[70px] px-[20px]"
                style={{
                    background:
                        "linear-gradient(180deg, rgba(15, 52, 96, 0.15) 0%, rgba(255, 255, 255, 0.15) 100%)",
                }}
            >
                <div
                    className="max-w-[1440px] mx-auto w-full mx-auto flex flex-col lg:flex-row items-center lg:gap-[80px] gap-[30px] py-[30px] sm:py-[44px] px-[20px] sm:px-[40px] rounded-[20px] sm:rounded-[30px] bg-white"
                    style={{ boxShadow: "0px 10px 100px 0px #89A1A82B" }}
                >
                    <div className="w-full lg:max-w-[485px] flex flex-col items-start">
                        <p className="font-[400] font-neue text-[15px] sm:text-[16px] leading-[26px] sm:leading-[30px] tracking-[-0.22px] text-[#05003E] pb-[10px]">
                            The U.S.–India relationship has entered a new phase — driven not just by
                            diplomacy or defense deals, but by deep technology, aligned capital, and
                            shared strategic intent. <br/>Yet too often, ideas stall between intent and
                            execution. Bureaucracy slows deals. Capital struggles to find credible
                            partners. Startups miss the moment. And good technologies get lost in
                            the fog of disconnected incentives.
                        </p>
                    </div>
                    <div className="w-full lg:max-w-[542px]">
                        <img
                            src="/assets/home/indus.jpg"
                            className="rounded-[15px] sm:rounded-[20px] w-full h-auto object-cover"
                            alt="US-India relations"
                        />
                    </div>
                </div>
            </section> */}
            {/* <section className="relative">
                <div className="absolute inset-0 bg-black/70 rounded-[20px]"></div>
                <img
                    src="/assets/what/inusa.jpg"
                    className="w-full h-[450px] md:h-[640px] object-cover rounded-[20px]"
                    alt="Background"
                />
                <div className="absolute top-0 left-1/2 -translate-x-1/2 max-w-[998px] w-full px-4 sm:px-6 md:px-8 pt-[40px] sm:pt-[60px] md:pt-[80px]">
                    <p className="font-[400] font-neue text-[14px] sm:text-[15px] md:text-[16px] leading-[24px] sm:leading-[26px] md:leading-[29px] tracking-[-0.22px] text-white text-center pb-[6px]">
                        We exist to change that.
                    </p>
                    <p className="font-[400] font-neue text-[14px] sm:text-[15px] md:text-[16px] leading-[22px] sm:leading-[24px] md:leading-[26px] tracking-[-0.22px] text-white text-center pb-[8px]">
                        Indus Tech operates in the space between — between governments and founders, between ambition and action, between policy and product.
                    </p>
                    <p className="font-[400] font-neue text-[14px] sm:text-[15px] md:text-[16px] leading-[24px] sm:leading-[26px] md:leading-[30px] tracking-[-0.22px] text-white text-center pb-[10px]">
                        We don’t build for noise. We move signal — intentionally, and only when the fit is real.
                    </p>
                    <h6 className="font-[600] font-neue italic text-[14px] sm:text-[15px] md:text-[16px] leading-[24px] sm:leading-[26px] md:leading-[29px] tracking-[-0.22px] text-white text-center pb-[20px] sm:pb-[24px] md:pb-[26px]">
                        Curated doesn’t mean quiet. It means intentional
                    </h6>
                    <h6 className="font-neue pt-[10px] sm:pt-[12px] font-neue font-[400] text-[22px] sm:text-[28px] md:text-[36px] leading-[32px] sm:leading-[42px] md:leading-[52px] text-white text-center max-w-[748px] w-full mx-auto">
                        To align people, capital, and decisions that move the{" "}
                        <span className="text-[#fff] italic">corridor forward.</span>
                    </h6>
                </div>
            </section> */}

            {/* <div className='ind-boxs '>
            <div className='max-w-[1440px] mx-auto '>
            <div className='ind-boxs-overlay   '>
                <h3>We exist to change that</h3>
                <div className='line'></div>
              

                <p className="font-[400] text-left font-neue max-w-[95%] lg:max-w-[600px] w-full 
            text-[14px] lg:text-[16px] leading-[22px] lg:leading-[20px] text-justify
            tracking-[-0.22px] text-white mt-[15px]">Indus Tech operates in the space between — between governments and founders, between ambition and action, between policy and product.We don’t build for noise. We move signal — intentionally, and only when the fit is real.

Curated doesn’t mean quiet. It means intentional.To align people, capital, and decisions that move the corridor forward.
        </p>

<h4></h4>
            </div>

</div>
            </div> */}

            <div
                className='the-corridor-div the-corridor-div2 the-corridor-div3'
                data-aos="fade-up"
                data-aos-duration="1000"
            >

                <div className='max-w-[1440px] mx-auto px-[20px] lg:px-[70px]'>
                    <h6
                        className="pb-[5px] text-left font-neue font-[400] text-[36px] leading-[38px] text-[#FFFFFF]"
                        data-aos="fade-up"
                        data-aos-delay="100"
                    >
                        How we work
                    </h6>
                    <div
                        className='line'
                        data-aos="zoom-in"
                        data-aos-delay="250"
                    ></div>
                    <br />
                    <p
                        className="font-[400] font-neue text-[16px] leading-[20px] tracking-[-0.22px] text-left text-[#FFFFFF] pb-[33px]"
                        data-aos="fade-up"
                        data-aos-delay="400"
                    >
                    We are selective about the clients we take on, screen every engagement for conflicts, and hold each one in confidence. We do not broker transactions, lobby, or work for foreign governments.
                    </p>

                </div>
            </div>


        </>
    )
}

export default WhyWeExist
